<template>
  <li
    :class="{
      'frisbuy-gallery-post': true,
      'frisbuy-podrygkashop-gallery-post': true,
      'frisbuy-video': post.media[0].videoUrl,
      'no-mobile': settings.hideMobThumbFooter,
      'frisbuy-multipost': post.media.length > 1
    }"
    @click="$emit('click')"
  >
    <div class="frisbuy-post-image">
      <div ref="photo" :style="{ 'background-image': `url(${ imageSource.imageLowRes })` }">
      </div>
      <img ref="image" :src="getDomainSubstitute(imageSource.imageHighRes)" @load="loadHandler" @error="errorImageHandler"/>
    </div>
    <div class="frisbuy-postitem-meta">
      <div class="frisbuy-postitem-meta__name">{{ post.instagramPost.authorUser.fio || post.instagramPost.authorUser.username }}</div>
      <div
        class="frisbuy-postitem-meta__likes"
        :class="{
          'frisbuy-postitem-meta__wasLiked': post.instagramPost.wasLiked,
          'frisbuy-postitem-meta__isLikesDisabled': isLikesDisabled,
        }"
        @click="$emit('like-click')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.89702 10.9565H3.69957C3.51404 10.9565 3.3361 11.0298 3.2049 11.1603C3.0737 11.2907 3 11.4677 3 11.6522V19.3043C3 19.4888 3.0737 19.6658 3.2049 19.7962C3.3361 19.9267 3.51404 20 3.69957 20H7.89702M7.89702 10.9565V20M7.89702 10.9565L11.3949 4C12.1371 4 12.8488 4.29317 13.3736 4.81501C13.8984 5.33685 14.1932 6.04461 14.1932 6.78261V8.86957H19.6062C19.8045 8.86908 20.0007 8.91081 20.1816 8.99197C20.3624 9.07312 20.5237 9.19182 20.6545 9.34008C20.7854 9.48834 20.8829 9.66274 20.9404 9.85156C20.9978 10.0404 21.014 10.2392 20.9878 10.4348L19.9385 18.7826C19.896 19.1177 19.7324 19.426 19.4782 19.65C19.224 19.874 18.8965 19.9984 18.5568 20H7.89702" stroke="#858F9A" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div>{{ post.instagramPost.likeCount }}</div>
      </div>
    </div>
  </li>
</template>

<script>
// Components
import defaultPostItem from "@/gallery/postitem/postitem.vue";

export default {
  mixins: [defaultPostItem],

  emits: ["click", "like-click"],

  props: {
    isContestEnded: {
        type: Boolean,
        require: false,
        default: true,
    },
  },

  computed: {
    isLikesDisabled() {
        const isDisabled = this.settings.disable_post_like || this.isContestEnded;
        return isDisabled;
    }
  }
}
</script>
